export const PAGE_VIEWED = 'Page Viewed';
export const NEWSLETTER_SUBSCRIBED = 'Newsletter Subscribed';

export const GET_QUOTES_CLICKED = 'pressed_get_quotes';
export const ENQUIRY_BUTTON_CLICKED = 'pressed_enquiry_button';
export const BREADCRUMB_CLICKED = 'pressed_breadcrumb';
export const SUPPLIER_PROFILE_CLICKED = 'pressed_top_supplier';
export const CUISINE_CLICKED = 'pressed_popular_cuisine';
export const RELATED_ARTICLE_CLICKED = 'pressed_article';
export const FAQ_TOGGLED = 'toggled_faq';
export const EVENT_TYPE_CLICKED = 'pressed_event_type';
export const LOCAL_LINK_CLICKED = 'pressed_something_more_local';
export const PAGE_SCROLLED = 'scrolled_page';
export const SUPPLIER_REVIEW_CLICKED = 'pressed_supplier_review';

export const categories = [
  {
    regex: /\/events\//g,
    type: 'Automated Landing Page',
  },
  {
    regex: /\/listings\//g,
    type: 'Listing Page',
  },
];
